/**
 * Onboarding workspace (S03) — founder + company + optional GSTIN autofill.
 *
 * @see prototype/onboarding/gstin.html — V1.1 Studio Slate baseline
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import {
  OnboardingShell,
  OnboardingHeader,
  Stepper,
  Hero,
  HeroNote,
  BrandFor,
  STEP_TITLES,
} from "../../../features/onboarding/components/index.ts";
import { ChevronLeft } from "lucide-react";
import { WorkspaceForm } from "../../../features/onboarding/components/workspace-form.tsx";

export const Route = createFileRoute("/(auth)/onboarding/workspace")({
  component: OnboardingWorkspace,
});

function OnboardingWorkspace() {
  return (
    <OnboardingShell
      header={
        <OnboardingHeader
          center={<Stepper current={3} titles={STEP_TITLES} />}
          right={
            <Link
              to="/sign-in/otp"
              className="inline-flex items-center gap-1 text-xs text-muted hover:text-ink-2"
            >
              <ChevronLeft size={14} />
              <span>Back</span>
            </Link>
          }
        />
      }
      brand={<BrandFor step="workspace" />}
      footer="Workspace creation starts the 14-day free trial · GSTIN can be added now or later"
    >
      <Hero
        kicker="Create your business workspace"
        title="Set up the company once. Keep the rest lightweight."
        description="Founder name, company name, and work email create the workspace. GSTIN is optional, but if you add it now Flint can pull the company profile and tax context automatically."
      >
        <HeroNote>The 14-day free trial starts as soon as this workspace is created.</HeroNote>
      </Hero>
      <WorkspaceForm />
    </OnboardingShell>
  );
}
